function modulo(a, b) {
  return a % b;
}

modulo.op = '%';

export default modulo;
